import { AUTH_HEADERS, BASE_URL } from "./BaseProxy";

const SHOWPATH_URL = `${BASE_URL}user/showpath/`;

export interface ShowPathTrack {
  position: number;
  track_id: string;
  name: string;
  track_role: string;
  track_type: string;
  track_name: string;
}

export interface ShowPathResponse {
  Feedback: string;
  tracks: Record<string, ShowPathTrack>;
}

export const getShowPath = async (
  userId: number
): Promise<ShowPathResponse> => {
  const url = `${SHOWPATH_URL}?userId=${encodeURIComponent(userId)}`;
  return await fetch(url, {
    method: "GET",
    mode: "cors",
    headers: AUTH_HEADERS,
  })
    .then((data) => data.json())
    .catch((err) => {
      return err;
    });
};
